export const defaultReminders = {
    '0': "Hello. You have an IPOS form that is overdue. Please click here to open the App to complete the form as soon as you can. Thank you.",
    '1': "Hello. You have an IPOS form that is overdue. Please click here to open the App to complete the form as soon as you can. Thank you."
}
export const REMINDER_TITLE = 'IPOS App reminder';
export const REMINDER_MAX_LENGTH = 400;

export const sendDefaultReminderTo = id => `Send Reminder to Patient ${id}`;
export const sendCustomReminderTo = id => `Send custom message to Patient ${id}`;
